export const customerExperienceQueryKeys = {
  root: ['customer-experience'],
  summary: ['customer-experience', 'summary'],
  overview: ['customer-experience', 'overview'],
  areas: (areaId = 'all') => ['customer-experience', 'areas', areaId],
  proactiveOutreach: ['customer-experience', 'proactive-outreach'],
  highRisk: ['customer-experience', 'high-risk-customers'],
  customer: (customerId) => ['customer-experience', 'customer', customerId],
};
